import React, { useEffect } from 'react';
import { useToaster } from 'react-hot-toast/headless';
import { useMeasure } from '../hooks/useMeasure.js';
import { Portal } from '../Portal/index.js';
import { runIfFn } from '../utils/index.js';
export const ToastContainer = () => {
    const { toasts, handlers: { calculateOffset, updateHeight, startPause, endPause }, } = useToaster();
    const getPositionStyle = (toast) => {
        const offset = calculateOffset(toast, {
            reverseOrder: false,
            gutter: 8,
            defaultPosition: 'top-right',
        });
        const positionStyle = {
            top: 16,
            right: 16,
            display: 'block',
            position: 'fixed',
            transition: `all 230ms cubic-bezier(.21,1.02,.73,1)`,
            transform: `translateY(${offset}px)`,
            animation: toast.visible
                ? 'toastFadeIn 100ms forwards'
                : 'toastFadeOut 100ms forwards',
        };
        return positionStyle;
    };
    return (React.createElement(React.Fragment, null, toasts.map(toast => (React.createElement(ToastWrapper, { id: toast.id, key: toast.id, onHeightUpdate: updateHeight, style: getPositionStyle(toast), onMouseEnter: startPause, onMouseLeave: endPause }, runIfFn(toast.message, toast))))));
};
const ToastWrapper = ({ id, className, style, onHeightUpdate, children, onMouseEnter, onMouseLeave, }) => {
    const [ref, { height }] = useMeasure();
    useEffect(() => {
        onHeightUpdate(id, height);
    }, [id, height, onHeightUpdate]);
    return (React.createElement(Portal, { idPrefix: "toast" },
        React.createElement("div", { ref: ref, className: className, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, children)));
};
//# sourceMappingURL=ToastContainer.js.map